import {makeLxTranslations} from "@lxo-blocks/react";

const FORGOT_PASSWORD_FORM_TRANSLATION =  makeLxTranslations({
    namespace: "forgotPasswordFormTranslations",
    translations: {
        FORGOT_PASSWORT_EMAIL: "Passwort vergessen? Kein Problem!",
        FORGOT_PASSWORT_EMAIL_SUCCESS: "Neues Passwort angefordert",
        FORGOT_PASSWORT_EMAIL_subtitle: "Bitte tragen Sie die E-Mail-Adresse ein, mit der Sie sich bei lexoffice registriert haben.",
        FORGOT_PASSWORT_EMAIL_SUCCESS_subtitle: "",
        MFA_CODE_REQUIRED: "Bitte geben Sie Ihren Code ein",

        ENTER_NEW_PASSWORD_AND_LOGIN: "Passwort festlegen",
        ENTER_NEW_PASSWORD_AND_LOGIN_IS_SUBMITTING: "Passwort wird festgelegt",

        FORGOT_PASSWORD_BUTTON_LABEL_IS_SUBMITTING: 'Neues Passwort wird angefordert',
        FORGOT_PASSWORD_BUTTON_LABEL_SEND: 'Neues Passwort anfordern',
        VALID_EMAIL_IS_REQUIRED: 'Bitte geben Sie eine gültige Email-Adresse ein',
        FORGOT_PASSWORD_LETTER_IMAGE_ALT_TEXT: "E-Mail-Briefumschlag mit Kennzeichnung einer neuen Nachricht",
        FORGOT_PASSWORD_SUCCESS_PAGE_TEXT1: 'Fast geschafft!',
        FORGOT_PASSWORD_SUCCESS_PAGE_TEXT2: 'Wir haben Ihnen soeben eine E-Mail an "{{email}}" gesendet. Klicken Sie auf den entsprechenden Link in der E-Mail.',
        FORGOT_PASSWORD_SUCCESS_PAGE_TEXT3: 'Sollte die E-Mail nicht ankommen, prüfen Sie bitte den Spam-Ordner Ihres E-Mail-Postfachs oder kontaktieren Sie unseren <anchor href="mailto:info@lexoffice.de">Support</anchor>.',

        PASSWORD_RESET_ERROR_HEADLINE: "Es ist ein Fehler aufgetreten!",

        EMAIL: "E-Mail",
        CANCEL: "Abbrechen",

        TOTP_CODE_WRONG: "Der eingegebene Code ist nicht gültig!",
        CONFIRMATION_TICKET_NOT_VALID: "Der Link ist ungültig oder wurde bereits eingelöst.",
        GENERAL_ERROR_TEXT: "Ihre Anfrage konnte nicht verarbeitet werden!",

        ERROR_PASSWORD_NOT_VALID: "Bitte geben Sie ein gültiges Passwort ein"
    }
});

export {FORGOT_PASSWORD_FORM_TRANSLATION};
